export default function getApiErrorMessage(error) {
  switch (error?.kind) {
    case 'timeout':
      return 'A busca demorou demais. Tente novamente.';
    case 'network':
      return 'Não foi possível conectar ao catálogo. Verifique sua conexão.';
    case 'auth':
      return 'Sua sessão expirou. Recarregue a página para entrar novamente.';
    default:
      return 'Não foi possível realizar a busca. Tente novamente.';
  }
}
